import React from 'react'
import { FaTag } from 'react-icons/fa';

const Offer = () => {
  return (
    <div className="mt-8 font-twentieth-century">
    <div className="flex items-center mb-2">
      <FaTag className="text-green-500 mr-2" />
      <p className="text-lg ">Get this on</p>
      <p className='font-semibold ml-1'>DISCOUNT</p>
    </div>
    <p className="text-sm text-gray-700">Buy now & Get Flat 10% Off! Code:<span className="font-semibold"> STITCHD10</span></p>
    <div className="flex items-center mt-4 mb-2">
      <FaTag className="text-green-500 mr-2" />
      <p className="text-lg">Get this on </p>
      <p className='font-semibold ml-1'>Extra Offers</p>
    </div>
    <p className="text-sm text-gray-700">Buy more & Get Flat 20% Off! Code: <span className="font-semibold"> STITCHD20</span></p>
  </div>
  )
}

export default Offer